import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-page45',
  templateUrl: './page45.component.html',
  styleUrls: ['./page45.component.css']
})
export class Page45Component implements OnInit {
  @Input() data: any;
  constructor() { }

  ngOnInit(): void {
  }

}
